import { Injectable, Injector } from '@angular/core';
import { ListData } from '@fi-app/components/items-list/list-data.service';
import { ISmsCostsDataListItem } from '@fi-app/sms/sms-costs/sms-costs';
import {
    ItemsListElementType,
    ItemsListHeader,
    ItemsListHeaderProperties,
} from '@fi-app/components/items-list/items-list-header';
import { IGetInstanceService } from '@fi-app/utilities/fi-model/get-instance-service';

@Injectable()
export class FiSmsCostsListDataService implements IGetInstanceService {
    constructor(private injector: Injector) {}

    getInstance(isLocalSort?: boolean) {
        return new SmsCostsListData(this.injector, isLocalSort);
    }
}

export class SmsCostsListData extends ListData<ISmsCostsDataListItem> {
    constructor(injector: Injector, isLocalSort?: boolean) {
        super(injector, isLocalSort);

        this.ChildProperty = 'ChildItems';
        this.ShowDelete = false;
        this.ShowCheckBox = false;

        this.Header.push(
            new ItemsListHeader(
                this.appTextService.get('sms.sender'),
                'Name',
                new ItemsListHeaderProperties('CcmListItem-Name', false, ItemsListElementType.SpanPlain),
            ),
        );

        this.Header.push(
            new ItemsListHeader(
                this.appTextService.get('sms.messages_sent'),
                'MessagesSent',
                new ItemsListHeaderProperties('', false, ItemsListElementType.SpanPlain),
            ),
        );

        this.Header.push(
            new ItemsListHeader(
                this.appTextService.get('sms.sms_cost'),
                'SmsCost',
                new ItemsListHeaderProperties('', false, ItemsListElementType.SpanPlain),
                undefined,
                undefined,
                (data) => data.SmsCost.toFixed(2),
            ),
        );
    }
}
